// this file added by Bearer Web Developer
import React, { useState } from "react"
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import { Observer } from "mobx-react-lite";
import { useAppState } from "../../states/app-state";
// useStyles removed by Bearer Web Developer


const IpAlertMessage: React.FC = () => {

    const appState = useAppState();
    const [open, setOpen] = useState<boolean>(true);
    const handleConfirm = () => {
        window.location.reload();
        setOpen(false);
        appState.profile.ipAlertMessage = false;
    }

    return (
        <Dialog
            className={''} PaperProps={{ style: { borderRadius: "10px" } }}
            open={open}
            maxWidth="sm"
        >
            <DialogContent>
                <DialogContentText>
                    <div className={''}>
                    For legal purposes, during the registration process,
                    we need to have access to your IP address. If necessary,
                    please turn off anti-virus software and try again.
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions >
                <Observer>{() => {

                    return (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleConfirm}
                            disabled={false}
                            className={''}
                        >
                            Agree
                        </Button>
                    )
                }}</Observer>
            </DialogActions>
        </Dialog>
    )
}

export default IpAlertMessage;